import { Component } from "@angular/core";
import {
	NavController,
	NavParams,
	ViewController,
	Events
} from "ionic-angular";

// import { SelectSearchableModule } from 'ionic-select-searchable';

import { ModalController } from "ionic-angular";


import { AddOrderServiceProvider } from "./../../pages/addorder/add-order.service";

import { APIServiceProvider } from "./../../common/services/api.service";
import { HelperServiceProvider } from "./../../common/services/helper.service";

import { ProductServiceProvider } from "./../../pages/products/product.service";
import {
	TechnicalModalPage
} from "../../modals/technicals/technicals.modal";

import {
	InventoryBreakupModalPage
} from "../../modals/inventory-breakup/inventory-breakup.modal";



@Component({
	selector: "modal-product",
	templateUrl: "./modal-product.html"
})
export class ProductModalPage {
	queryText: string;
	requestType: any = "products";
	requestIndex: any = null;
	requestIndexSubstitute: any = null;
	customer_id: any = null;

	search: any = null;

	hasLoadData: any = true;

	depo_name:any;

	public technical_code: any = null;
	public technical_name = null;


	public postParams: any = {
		limit: 10,
		offset: 0,
		technical_code:null,
		search: this.search


	};

	public showProducts:boolean=true;

	public showSubstitute:boolean=false;


	public selected_filters: any = {};

	public composition_list: any = [];
	public productList = [];

	public technical_codee :any;

	public product_field_app_name:any;

	public filtered_name:any;
	public filteredHeader :boolean=false;
	public disableField:boolean=false;




	constructor(
		public navCtrl: NavController,
		public modalCtrl: ModalController,
		public productService: ProductServiceProvider,
		public viewCtrl: ViewController,
		public addOrderService: AddOrderServiceProvider,
		public events: Events,
		public helperService: HelperServiceProvider,
		public apiService: APIServiceProvider,
		public navParams: NavParams
		) {
		this.requestIndex = navParams.get("index");
		this.customer_id = navParams.get("customer_id");

	}

	ionViewDidLoad() {
		this.getProducts();
		this.getFilters();


	}

	getProducts() {
		this.apiService
		.post(
			"products/get-products",
			{
				limit: 10,
				search: this.search,
				customer_id: this.customer_id,
				technical_code: this.postParams.technical_code

			},
			null,
			false
			)
		.subscribe(products => {

			products["data"]["data"].forEach(function(item) {
		        item.product_selling_price = item.selling_price; 
		    });

			this.productService.productResponse = products["data"];
			this.productService.products = products["data"]["data"];
			this.depo_name = products["depo_name"];


			if (products["data"]["data"].length < 10) {
				this.hasLoadData = false;
			} else {
				this.hasLoadData = true;
			}
		});
	}

	doInfiniteScroll(infiniteScroll) {
		if (
			!this.productService.productResponse.next_page_url ||
			this.productService.productResponse.next_page_url === "" ||
			this.productService.productResponse.next_page_url === null ||
			this.productService.productResponse.next_page_url === "null"
			) {
			return;
	}

	this.apiService
	.post(
		"products/get-products",
		{ limit: 10, technical_code:this.postParams.technical_code, search: this.search },
		this.productService.productResponse.next_page_url,
		false
		)
	.subscribe(products => {

		products["data"]["data"].forEach(function(item) {
	        item.product_selling_price = item.selling_price; 
	    });
 
		infiniteScroll.complete();

		if (products["data"]["data"].length < 10) {
			this.hasLoadData = false;
		} else {
			this.hasLoadData = true;
		}

		this.productService.productResponse = products["data"];
		this.productService.products = this.productService.products.concat(
			products["data"]["data"]
			);
	});
}

selectProduct(product) {
	product.requestIndex = this.requestIndex;
	this.events.publish("addorderproduct-selected", product);

	this.dismiss();
}

onClear(ev: any) {
	this.search = null;
	this.getProducts();
	ev.stopPropagation();
}

onCancel(ev: any) {
	this.search = null;
	this.getProducts();
}



filterProduct(ev: any) {
	let val = ev.target.value;

	if (typeof val === "undefined") {
		return;
	}

	this.search = val;
	this.getProducts();
}

dismiss() {
	this.viewCtrl.dismiss();
}


getFilters() {
	let url = 'technical/get-filters/en';
	console.log(url);
	this.apiService.get(url).subscribe(response => {
		this.composition_list = response["composition"];
		console.log(this.composition_list);
	}, err => {
		console.log(err);
	})
}

filterProductTechnicals() {
	Object.keys(this.selected_filters).forEach(filter => {
		delete this.postParams.technical_code;
		if (this.selected_filters[filter] && this.selected_filters[filter].length !== 0) {
			if (filter === 'technicals'){
				this.postParams.technical_code=this.selected_filters.technicals;
				// this.postParams.technical_code = this.postParams.technical_code.toString();
				this.postParams.technical_code=this.gettingCodes(this.selected_filters.technicals);
				this.postParams.technical_code = this.postParams.technical_code.toString();
				console.log(this.postParams.technical_code);  
			}
		}

		this.composition_list.map(tech=>{
			if(tech.code==this.postParams.technical_code){
				this.filtered_name=tech.value
			}
		})


	});
	this.getProducts();
	this.filteredHeader=true;
	this.disableField=true;

}


gettingCodes(item: any) {
	if (Array.isArray(item) && item.length > 0 ) {
		return item.map((o) => o !== undefined && o !== null && o.code? o.code :o);
	}
	else if(item !== undefined && item !== null) {
		return [item.code];
	}else{
		return null;
	}
}

clearFilters() {
	Object.keys(this.selected_filters).forEach(filter => {
		delete this.postParams.technical_code;
		delete this.selected_filters.technical_code;
		this.selected_filters.technicals=null;
		console.log(this.selected_filters.technicals);

	});
	this.getProducts();
	this.filteredHeader=false;
	this.disableField=false;

}




getSubstitute(products) {
	this.requestIndexSubstitute = this.navParams.get("index");
	this.technical_code = products["technical_code"];
	//console.log(this.technical_code);
	this.technical_name= products["technical_name"],
	this.product_field_app_name= products['product_field_app_name']

	//console.log(this.technical_name);
	localStorage.setItem(
		"technical_code",
		this.technical_code
		);
	this.apiService
	.post(
		"technical/get_substitute",
		{ limit: 10, technical_code:this.technical_code, search: this.search },null,false
		)
	.subscribe(products => {

		this.productService.productResponse = products;
		this.productService.products = products["data"];
		
		console.log(this.productService.products);
		if (products["data"].length < 10) {
			this.hasLoadData = false;
		} else {
			this.hasLoadData = true;
		}
	});

	this.showProducts=false;
	this.showSubstitute=true;
}

doInfiniteScrollSubstitute(infiniteScroll) {
	this.technical_codee=localStorage.getItem(
		"technical_code",
		);
	console.log(this.technical_codee);
	if (
		!this.productService.productResponse.next_page_url ||
		this.productService.productResponse.next_page_url === "" ||
		this.productService.productResponse.next_page_url === null ||
		this.productService.productResponse.next_page_url === "null"
		) {
		return;
}

this.apiService

.post(
	"technical/get_substitute",
	{ limit: 10, technical_code:this.technical_codee},this.productService.productResponse.next_page_url,
	false
	)
.subscribe(products => {
	infiniteScroll.complete();

	if (products["data"].length < 10) {
		this.hasLoadData = false;
	} else {
		this.hasLoadData = true;
	}

	this.productService.productResponse = products;
	this.productService.products = this.productService.products.concat(
		products["data"]
		);
});
localStorage.removeItem(this.technical_codee);
console.log(localStorage.removeItem(this.technical_codee));
}


showTechnicalDetailsModal(products) {
	console.log(products);
	let modalObject = this.modalCtrl.create(
		TechnicalModalPage, {
			technical_name: products['technical_name'],


		}

		);

	modalObject.present();
}

showInventoryBreakUpModal(products) {
	console.log(products);
	let modalObject = this.modalCtrl.create(
		InventoryBreakupModalPage, {
			product_id: products['product_id'],


		}

		);

	modalObject.present();
}



backToProducts(){
	this.showProducts=true;
	this.showSubstitute=false;
	this.filteredHeader=false;
	this.disableField=false;

	this.clearFilters();


}
}



// WEBPACK FOOTER //
// ./src/modals/product/product.modal.ts